import React, { useCallback, useMemo } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import {
  addBusinessDays,
  compareDateOnly,
  isWeekend,
  removeBusinessDays,
} from "../../../utils/dateHelpers";
import { Value } from "react-calendar/dist/shared/types.js";
import styles from "./RequestOtherDeliveryDates.module.scss";
import { Button } from "@ds";
import { ButtonStyle, ButtonVariant } from "@ds/elements/Button/Button.types";

interface IRequestOtherDeliveryDatesCalendarProps {
  fromDate: Date;
  toDate: Date;
  requestFromDate: Date | null;
  requestToDate: Date | null;
  onDateRangeChange: (startDate: Date | null, endDate: Date | null) => void;
}

const RequestOtherDeliveryDatesCalendar: React.FC<
  IRequestOtherDeliveryDatesCalendarProps
> = ({ fromDate, toDate, requestFromDate, requestToDate, onDateRangeChange }) => {
  const handleClearClick = () => {
    onDateRangeChange(null, null);
  };


  const maxDate = useMemo(() => addBusinessDays(fromDate, 8 * 5), [fromDate]);

  const handleDateChange = useCallback(
    (selectedStartDate: Value) => {
      const dateRange = 4;
      const selectedEndDate = addBusinessDays(selectedStartDate as Date, dateRange);
      let endDate = selectedEndDate;
      let startDate = selectedStartDate as Date;

      if (compareDateOnly(selectedEndDate, maxDate) > 0) {
        endDate = maxDate;
        startDate = removeBusinessDays(maxDate, dateRange);
      }

      onDateRangeChange(startDate, endDate);
    },
    [maxDate, onDateRangeChange]
  );

  return (
    <div className={styles['delivery-date-calendar']}>
      <Calendar
        selectRange={false}
        minDetail="month"
        maxDate={maxDate}
        minDate={fromDate}
        calendarType="gregory"
        onChange={handleDateChange}
        defaultActiveStartDate={fromDate}
        className={styles['delivery-date-component']}
        tileDisabled={({ date }) => isWeekend(date)}
        value={[requestFromDate || fromDate, requestToDate]}
      />
      <div className={styles['delivery-date-button-wrapper']}>
        <Button 
          variant={ButtonVariant.contained}
          styleType={ButtonStyle.danger}
          onClick={handleClearClick}
        >
          Clear
        </Button>
      </div>
    </div>
  );
};

export default RequestOtherDeliveryDatesCalendar;